import axios from "axios";
// import qs from "qs";
import { Toast, Dialog } from "vant";
import store from "@/store";
import { Loading } from "element-ui";
import baseURL from "../api/baseUrl";
// import { getToken } from "@/utils/auth";

// 创建一个axios实例
const service = axios.create({
  baseURL: baseURL,
  withCredentials: true,
  timeout: 15000,
});

service.interceptors.request.use(
  (config) => {
    if (store.getters.token) {
      // 让每个请求携带令牌——['Has-Token']作为自定义密钥。
      // 请根据实际情况修改。
      // config.headers["Has-Token"] = getToken();
    }
    //在这里根据自己相关的需求做不同请求头的切换，我司是需要使用这两种请求头。
    // if (config.json) {
    config.headers["Content-Type"] = "application/json";
    // } else {
    // config.headers["Content-Type"] =
    //   "application/x-www-form-urlencoded;charset=UTF-8";
    // config.data = qs.stringify(config.data); //利用qs做json序列化
    // }
    return config;
  },
  (error) => {
    // 处理请求错误
    return Promise.reject(
      Toast({
        message: error,
        icon: "cross",
        duration: 3000,
      })
    );
  }
);
service.interceptors.response.use(
  (response) => {
    const res = response.data; //这是响应返回后的结果
    //在这里可以根据返回的状态码对存在响应错误的请求做拦截，提前做处理。

    //以下为我司的处理规则
    // 如果自定义代码不是200，则判断为错误。
    if (res.code == 200 || res.code == 300) {
      // 重新登陆

      return;
    } else {
      if (res.code == 700) {
        Toast({
          message: "您没有获取请求的权限",
          icon: "cross",
          duration: 3000,
        });
        return;
      } else if (res.code == 0) {
        return res;
      } else if (res.code == 11) {
        return res;
      } else {
        var text;
        console.log(res.msg);
        if (res.msg === "账户余额不足") {
          return res;
        } else {
          if (res.msg.includes("<p>")) {
            // 创建一个DOMParser实例
            var parser = new DOMParser();

            // 使用DOMParser解析HTML字符串，并获取解析后的文档对象
            var doc = parser.parseFromString(res.msg, "text/html");

            // 获取<p>标签
            var pTag = doc.querySelector("p");

            // 读取<p>标签中的文本
            text = pTag.textContent;
          } else {
            text = res.msg;
          }
          setTimeout(() => {
            Toast({
              duration: 3000,
              message: text,
              icon: "cross",
            });
          }, 100);
        }

        // Loading.service().close();
      }
    }
    //end
  },
  (error) => {
    Toast({
      duration: 3000,
      message: error.message,
      icon: "cross",
    });
    return Promise.reject(error);
  }
);

export default service;
